
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LocationTransferItemsGrid extends Serenity.EntityGrid<LocationTransferItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.LocationTransferItems'; }
        protected getDialogType() { return LocationTransferItemsDialog; }
        protected getIdProperty() { return LocationTransferItemsRow.idProperty; }
        protected getInsertPermission() { return LocationTransferItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return LocationTransferItemsRow.localTextPrefix; }
        protected getService() { return LocationTransferItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}